module.exports = __webpack_public_path__ + "img/icon_kruimel.3a1049db.png";